moduleViewApp.directive('draggable', [->
  restrict: 'A',
  link: (scope, element, attrs)  ->
    element[0].addEventListener('dragstart', scope.handleDragStart, false)
    element[0].addEventListener('dragend', scope.handleDragEnd, false)
])

moduleViewApp.directive('droppable', [->
  restrict: 'A',
  link: (scope, element, attrs)  ->
    element[0].addEventListener('drop', scope.handleDrop, false)
    element[0].addEventListener('dragover', scope.handleDragOver, false)
    element[0].addEventListener('dragleave', scope.handleDragLeave, false)
])

moduleViewApp.controller('partnerEditorCtrl', ['$scope', '$timeout', '$q', 'myPartnersService', 'PartnersResource', 'SetCollaboratorsResource', 'SeriesCollaboratorsResource', 'UserSeriesCollaboratorsResource', 'PartnerUserRolesResource', ($scope, $timeout, $q, myPartnersService, PartnersResource, SetCollaboratorsResource, SeriesCollaboratorsResource, UserSeriesCollaboratorsResource, PartnerUserRolesResource) ->
  window.debug = window.debug || {}
  window.debug["partnerEditorCtrl"] = $scope

  _.assignIn $scope, {
    search: {}
    sets_summary_bucket: []
    series_summary_bucket: []
    collaborated_sets: []
    collaborated_series: []
    tabContent: {}
    select_options: {}
    editorTemplate: Packs.iKnowRoutes.sets_v2_templates_path("assign_editor")
    routes: Packs.iKnowRoutes

    handleDragStart: (e) ->
      this.style.opacity = '0.4';
      if e.toElement
        element = e.toElement
      else
        element = e.target

      e.dataTransfer.setData('draggableType', element.dataset.draggableType)

      set_ids = _.map(_.filter($scope.collaborated_sets, (set) ->
        return set.selected
      ),"id")
      angular.element("#drag-and-drop-status").html("Copying " + set_ids.length + " sets")
      e.dataTransfer.setDragImage(angular.element("#drag-and-drop-status")[0], 0, 0);
      e.dataTransfer.setData('set_ids', set_ids)

    handleDragEnd: (e) ->
      this.style.opacity = '1.0'
      angular.element(".group-partner--group-content").removeClass("drag-hover")

    handleDrop: (e) ->
      e.preventDefault()
      e.stopPropagation()

      set_ids = e.dataTransfer.getData('set_ids')
      set_ids = set_ids.split(",")
      $scope.addCollaborators(e.currentTarget.getAttribute("user-id"), set_ids)
      $scope.confirm_message = set_ids.length + " sets were added."
      $scope.selectAll($scope.collaborated_sets, false)
      $timeout( ->
        $scope.confirm_message = null
      , 5000)

    handleDragOver: (e) ->
      e.preventDefault()
      angular.element(e.target).closest(".group-partner--group-content").addClass("drag-hover")
      e.dataTransfer.dropEffect = 'move'
      return false

    handleDragLeave: (e) ->
      e.preventDefault()
      angular.element(".group-partner--group-content").removeClass("drag-hover")

    loadAllEditors: ->
      return if !$scope.partner
      PartnerUserRolesResource.roles
        partner_id: $scope.partner.id,
        "filter[role]": "editor"
        include: "user"
        'page[size]': 200
      , (success) ->
        # we only care about the user objects, so just set editors to success.included and throw away success.data
        $scope.editors = success.included
      , (error) ->
        console.error error

    reset: ->
      $scope.search.text = null
      $scope.setsSearchResult = []
      $scope.seriesSearchResult = []
      $scope.select_options.sets_select_all = false

    loadCollaborations: ->
      $scope.editorsLoading = true
      setsPromise = PartnersResource.sets { partner_id: $scope.partner.id, collaborator_only: true, user_id: $scope.currentEditor.id, include_remix: true }
      , { }
      , (success) ->
        $scope.collaborated_sets = success.response.sets
      .promise
      seriesPromise = UserSeriesCollaboratorsResource.query { user_id: $scope.currentEditor.id }, { partner_id: $scope.partner.id }
      , (success) ->
        $scope.collaborated_series = success.data
      .promise
      $q.all([setsPromise, seriesPromise]).then () ->
        $scope.reset()
        $scope.editorsLoading = false

    getModuleSearchResult: ->
      PartnersResource.sets { partner_id: $scope.partner.id, search: $scope.search.text }
      , { }
      , (success) ->
        $scope.setsSearchResult = success.response.sets

      PartnersResource.series { partner_id: $scope.partner.id, search: $scope.search.text }
      , { }
      , (success) ->
        $scope.seriesSearchResult = success.response.series

    setCurrentEditor: (editor) ->
      return if $scope.currentEditor && ($scope.currentEditor.id == editor.id)
      $scope.currentEditor = editor
      $scope.tabContent.edit = false
      $scope.loadCollaborations()

    toggleModuleList: (module) ->
      return if module.disabled
      if module.selected
        $scope.removeFromBucket(module)
      else
        if module.module_type == "set"
          $scope.sets_summary_bucket.push(module)
        else
          $scope.series_summary_bucket.push(module)

      module.selected = !module.selected

    removeFromBucket: (module) ->
      $scope.sets_summary_bucket = _.reject($scope.sets_summary_bucket.concat($scope.series_summary_bucket), (s) ->
        return s.id == module.id
      )

    selectAll: (collection, value) ->
      for c in collection
        c.selected = value

    removeModules: ->
      $scope.editorsLoading = true
      set_ids_to_remove = _.map(_.filter($scope.collaborated_sets, (module) ->
        return module.selected
      ), "id")
      series_ids_to_remove = _.map(_.filter($scope.collaborated_series, (module) ->
        return module.selected
      ), "id")

      promises = []
      if set_ids_to_remove.length > 0
        promises.push(SetCollaboratorsResource.delete({ "set_ids[]": set_ids_to_remove, user_id: $scope.currentEditor.id }).promise)
      for id in series_ids_to_remove
        promises.push(SeriesCollaboratorsResource.delete({ series_id: id, id: $scope.currentEditor.id }).promise)

      $q.all(promises).then () ->
        $scope.loadCollaborations()

    addModules: ->
      $scope.editorsLoading = true
      promises = []
      if $scope.sets_summary_bucket.length > 0
        _.extend($scope.collaborated_sets, $scope.sets_summary_bucket)
        promises.push(SetCollaboratorsResource.create({ }, { user_id: $scope.currentEditor.id, 'set_ids': _.map($scope.sets_summary_bucket, "id"), batch_email: true, partner_id: $scope.partner.id }).promise)

      for series in $scope.series_summary_bucket
        $scope.collaborated_series.push(series)
        promises.push(SeriesCollaboratorsResource.create({ series_id: series.id}, {user_id: $scope.currentEditor.id, partner_id: $scope.partner.id }).promise)

      $q.all(promises).then (results) ->
        $scope.sets_summary_bucket = []
        $scope.series_summary_bucket = []
        $scope.tabContent.edit = false
        $scope.editorsLoading = false
  }

  $scope.debouncedGetModuleSearchResult = _.debounce($scope.getModuleSearchResult, 200)

  myPartnersService.initialize().then () ->
    $scope.partner = myPartnersService.currentProductPartner
    $scope.loadAllEditors()
])
